import { createSelector } from "reselect";
const oidcSelector = (state) => state.oidc;
export const getOidcUser = createSelector(oidcSelector, (oidc) => {
    return oidc.user !== undefined ? oidc.user : undefined;
});
export const getOidcAccessToken = createSelector(oidcSelector, (oidc) => (oidc.user ? oidc.user.access_token : "no token available"));
export const getOidcUserRoles = createSelector(oidcSelector, (oidc) => (oidc.user && oidc.user.profile.role) || []);
